// extracted by mini-css-extract-plugin
module.exports = {"LoginFormBlock__formItem":"LoginForm_LoginFormBlock__formItem__3O_Tu","LoginFormBlock__formItem_last":"LoginForm_LoginFormBlock__formItem_last__3HFIU"};